document.addEventListener('DOMContentLoaded', () => {
	// Filter files by folder (category)
	const folderFilters = document.querySelectorAll('button[data-folder-id]')
	const filesList = document.querySelector('ul.files')
	const files = document.querySelectorAll('li[data-folder-id]')

	folderFilters?.forEach(filter => {
		filter.addEventListener('click', e => {
			folderFilters.forEach(filter => {
				filter.classList.remove('selected')
			})
			filter.classList.add('selected')

			files.forEach(file => {
				let folderIds = file.dataset.folderId.split(',')
				if (
					e.target.dataset.folderId === '0' ||
					folderIds.includes(e.target.dataset.folderId)
				) {
					file.classList.remove('hidden')
				} else {
					file.classList.add('hidden')
				}
			})
		})
	})

	// Sort files by year or name
	const sortYearButton = document.querySelector('button[data-sort="year"]')
	const sortNameButton = document.querySelector('button[data-sort="name"]')
	const sortSelect = document.querySelector('select#sort')

	// Set up possible sort options as arrays so we don't have to re-do the work if they end up re-selecting a previous sort option
	let sortedYearDesc = Array.from(files)
	let sortedYearAsc = sortedYearDesc.toReversed()
	let sortedNameDesc = Array.from(files).sort((a, b) =>
		b.dataset.name.localeCompare(a.dataset.name),
	)
	let sortedNameAsc = sortedNameDesc.toReversed()

	sortYearButton?.addEventListener('click', () => {
		sortYearButton.classList.add('selected')
		sortNameButton.classList.remove('selected')

		if (sortYearButton.classList.contains('desc')) {
			sortYearButton.classList.remove('desc')
			sortYearButton.classList.add('asc')

			sortSelect.value = 'yearAsc'

			filesList.replaceChildren(...sortedYearAsc)
		} else {
			sortYearButton.classList.add('desc')
			sortYearButton.classList.remove('asc')

			sortSelect.value = 'yearDesc'

			filesList.replaceChildren(...sortedYearDesc)
		}
	})

	sortNameButton?.addEventListener('click', () => {
		sortNameButton.classList.add('selected')
		sortYearButton.classList.remove('selected')

		if (sortNameButton.classList.contains('desc')) {
			sortNameButton.classList.remove('desc')
			sortNameButton.classList.add('asc')

			sortSelect.value = 'nameAsc'

			filesList.replaceChildren(...sortedNameAsc)
		} else {
			sortNameButton.classList.add('desc')
			sortNameButton.classList.remove('asc')

			sortSelect.value = 'nameDesc'

			filesList.replaceChildren(...sortedNameDesc)
		}
	})

	sortSelect?.addEventListener('change', () => {
		const selectedValue = sortSelect.value

		switch (selectedValue) {
			case 'nameAsc':
				sortNameButton.classList.add('selected')
				sortYearButton.classList.remove('selected')
				sortNameButton.classList.add('asc')
				sortNameButton.classList.remove('desc')
				filesList.replaceChildren(...sortedNameAsc)
				break
			case 'nameDesc':
				sortNameButton.classList.add('selected')
				sortYearButton.classList.remove('selected')
				sortNameButton.classList.add('desc')
				sortNameButton.classList.remove('asc')
				filesList.replaceChildren(...sortedNameDesc)
				break
			case 'yearAsc':
				sortYearButton.classList.add('selected')
				sortNameButton.classList.remove('selected')
				sortYearButton.classList.add('asc')
				sortYearButton.classList.remove('desc')
				filesList.replaceChildren(...sortedYearAsc)
				break
			case 'yearDesc':
				sortYearButton.classList.add('selected')
				sortNameButton.classList.remove('selected')
				sortYearButton.classList.add('desc')
				sortYearButton.classList.remove('asc')
				filesList.replaceChildren(...sortedYearDesc)
				break
		}
	})

	// Open/close details depending on screen size
	const details = document.querySelector('.subfolders-wrapper details')
	// Do it once on page load
	if (details) {
		if (window.innerWidth >= 992) {
			details.open = true
		} else {
			details.open = false
		}
		// Update it on resize
		window.addEventListener('resize', () => {
			if (window.innerWidth >= 992) {
				details.open = true
			} else {
				details.open = false
			}
		})
	}
})
